<template>
  <div class="subcontent">
    <div class="subbanner" :style="{ backgroundImage: 'url(' + pageContent.topbanner + ')' }">
      <div class="container">
        <h1 class="title">{{ pageContent.bigadtext }}</h1>
        <span>{{ pageContent.smalladtext }}</span>
      </div>
    </div>
    <div class="mainwrap">
      <div class="container">
        <div class="submain">
          <div class="titleA"><strong>{{ pageContent.title }}</strong></div>
          <div class="news-list">
            <div v-for="item in newsList" :key="item.id" class="news-item" @click="goToNewsDetail(item)">
              <h3>{{ item.title }}</h3>
              <p class="news-date">{{ item.created_at }}</p>
            </div>

            <div v-if="newsList.length === 0" class="no-data">
              暂无新闻资讯
            </div>
          </div>

          <!-- 分页组件 -->
          <div class="pagination" v-if="total > 0">
            <el-pagination @current-change="handlePageChange" :current-page="currentPage" :page-size="pageSize"
              layout="total, prev, pager, next" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pageApi, newsApi } from '@/api'

export default {
  name: 'News',
  data() {
    return {
      pageContent: "",
      newsList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    // 使用固定的ID查询，例如ID为1的页面
    this.fetchAboutPage(7)
  },
  created() {
    this.fetchNewsList()
  },
  methods: {
    async fetchAboutPage(pageId) {
      try {
        const { data } = await pageApi.getPageByParams({
          id: pageId
        })

        this.pageContent = data
      } catch (error) {
        console.error('获取关于页面失败:', error)
      }
    },
    async fetchNewsList() {
      try {
        const params = {
          page: this.currentPage,
          pagesize: this.pageSize
        }
        const response = await newsApi.getNewsList(params)

        this.newsList = response.data.list
        this.total = response.data.total
      } catch (error) {
        console.error('获取新闻列表失败:', error)
      }
    },

    handlePageChange(page) {
      this.currentPage = page
      this.fetchNewsList()
    },

    goToNewsDetail(item) {
      // 在新窗口中打开新闻链接
      window.open(item.linkurl, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.subcontent {
  font-size: 16px;
  line-height: 1.8;

  .subbanner {
    height: 400px;
    width: 100%;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    color: #fff;
    text-shadow: -2px -2px 1px #313131;

    .title {
      font-size: 50px;
      letter-spacing: 0px;
      line-height: 32px;
    }

    span {
      position: relative;
      font-size: 30px;
      font-family: 'Times New Roman', Times, serif;
    }
  }

  .news-list {
    padding: 20px 0;

    .news-item {
      padding: 20px;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #f5f5f5;
      }

      h3 {
        margin: 0 0 10px 0;
        color: #333;
        font-size: 18px;
      }

      .news-link {
        color: #666;
        font-size: 14px;
        margin: 5px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .news-date {
        color: #999;
        font-size: 14px;
        margin: 5px 0 0 0;
      }
    }

    .no-data {
      text-align: center;
      padding: 50px;
      color: #999;
    }
  }

  .pagination {
    text-align: center;
    margin: 30px 0;
  }
}

// 移动端适配样式
@media (max-width: 768px) {
  .subcontent {
    font-size: 1rem;
    line-height: 1.6;

    .subbanner {
      
      .container {
        padding-left: 1rem !important;
      }

      .title {
        font-size: 1.8rem !important;
        line-height: 1.4em !important;
      }

      span {
        font-size: 1.2rem !important;
      }
    }

    .news-list {
      padding: 1rem 0;

      .news-item {
        padding: 1rem !important;
        h3 {
          font-size: 1.1rem !important;
          margin: 0 0 0.5rem 0 !important;
        }

        .news-date {
          font-size: 0.8rem !important;
          margin: 0.3rem 0 0 0 !important;
        }
      }

      .no-data {
        padding: 2rem 1rem !important;
        font-size: 0.9rem !important;
      }
    }

    .pagination {
      margin: 1.5rem 0 !important;
      
      .el-pagination {
        .el-pager {
          .number {
            padding: 0.2rem 0.4rem !important;
            font-size: 0.9rem !important;
          }
        }
      }
    }
  }
}
</style>